/*
 * @Author: cc
 * @Date: 2020-03-31 16:16:47
 * @LastEditTime: 2021-03-30 16:00:50
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\manageConfig\productManageMent\app\app.js
 * @Description: 
 */
'use strict';
angular.module('productManageMentAppModule', [
    'productManageMentAppRouterModule',
    'productManageMentAppChannelModule',
    'productManageMentAppColumnModule',
    // 'productManageMentAppDistributeConfigModule',
    'manageProAppSiteModule',
    'productManageMentAppTemplateModule',
    'productManageMentAppServiceModule',
    'productManageMentAppServiceModule',
    'editManuSourceAppModule',
    'proManaMentAppHeaderModule',
    'productManageMentAppExternalSysModule',
    'productManageMentAppTagManagerModule',
    'productManageMentAppsiteWatermarkMgrModule',
    'appThirdParyConfigModule' // 组件接口管理
])
    . controller('appController', ['$scope', '$state', 'trsHttpService', 'modalDialog', '$modal', '$stateParams', 'localStorageService', 'productMangageMentAppService', function($scope, $state, trsHttpService, modalDialog, $modal, $stateParams, localStorageService, productMangageMentAppService) {
    // $state.go("manageconfig.productmanage.app.site");
    }]);
